<template>
    <button class="actionButton" @click="doClick">
        <div class="mark">
            <IconBase iconName="修正"><IconPencil /></IconBase>
        </div>
        <div class="txt">修正</div>
    </button>
</template>

<script>
import MopButtonMixin from "@/components/buttons/MopButtonMixin.vue";
import IconPencil from "@/components/icons/IconPencil.vue";

export default {
    name: "MopModifyButton",
    mixins: [MopButtonMixin],
    components: {
        IconPencil
    }
};
</script>
